export const requiredRule = () => (v) => v ? true : "Pflichtfeld";

export const passwordRule = () => (v) =>
  (v?.length >= 8 && v.length <= 64 && /[A-Z]/.test(v) && /[a-z]/.test(v) && /[0-9]/.test(v)) ||
  "Das Passwort muss mindestens 8 Zeichen lang sein und mindestens einen Großbuchstaben, einen Kleinbuchstaben sowie eine Zahl enthalten.";

export const dateRule = () => (v) => {
  if (!v) return true;
  if (v instanceof Date) return !isNaN(v) || "Bitte geben Sie ein gültiges Datum im Format TT.MM.JJJJ ein.";

  const regex = /^\d{2}\.\d{2}\.\d{4}$/;
  if (!regex.test(v)) return "Bitte geben Sie ein gültiges Datum im Format TT.MM.JJJJ ein.";
  const [d, m, y] = v.split(".").map(Number);
  const parsed = new Date(y, m - 1, d);
  return (
    (parsed.getFullYear() === y && parsed.getMonth() === m - 1 && parsed.getDate() === d) || "Bitte geben Sie ein gültiges Datum im Format TT.MM.JJJJ ein."
  );
};

export const minDateRule = (min) => (v) => !v || toDate(v) >= startOfDay(min) || `Datum vor ${min.toLocaleDateString()}`;
export const maxDateRule = (max) => (v) => !v || toDate(v) <= startOfDay(max) || `Datum nach ${max.toLocaleDateString()}`;

const toDate = (v) => {
  if (v instanceof Date) return v;

  if (typeof v === "string") {
    const [d, m, y] = v.split(".").map(Number);
    if (d && m && y) return new Date(y, m - 1, d);
  }

  return new Date(NaN); // ungültig
};

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

export const currencyRule = () => (v) => {
  if (!v) return true;
  const regex = /^\d+([.,]\d{1,2})?$/;
  return regex.test(v) || "";
};

export const emailRule = () => (v) => {
  if (!v) return true;
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(v) || "Bitte eine gültige E-Mail-Adresse im Format name@beispiel.de eingeben.";
};

export const telRule = () => (v) => {
  if (!v) return true;
  const regex = /^[1-9][0-9]{3,13}$/;
  return regex.test(v) || "Bitte eine gültige Telefonnummer im Format +49 151 23456789 eingeben.";
};

export const mobileRule = () => (v) => {
  if (!v) return true;
  const regex = /^[1-9][0-9]{6,13}$/;
  return regex.test(v) || "Bitte eine gültige Mobilfunknummer im Format +49 151 23456789 eingeben.";
};

export const landlineRule = () => (v) => {
  if (!v) return true;
  const regex = /^[1-9][0-9]{3,11}$/;
  return regex.test(v) || "Bitte eine gültige Festnetznummer im Format +49 151 23456789 eingeben.";
};

export const zipCodeRule = () => (v) => {
  if (!v) return true;
  const regex = /^\d{4,6}$/;
  return regex.test(v) || "";
};

export const urlRule = () => (v) => {
  if (!v) return true;
  const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/)?$/;
  return regex.test(v) || "Bitte eine gültige URL eingeben (z.B. www.beispiel.de).";
};

export const ibanRule = () => (v) => {
  if (!v) return true;

  const iban = v.replace(/\s+/g, "").toUpperCase();

  const regex = /^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/;
  if (!regex.test(iban)) return "Bitte eine gültige IBAN eingeben (z.B. DE12 3456 7890 1234 5678 90).";

  const rearrangedIban = iban.slice(4) + iban.slice(0, 4);

  const numericIban = rearrangedIban.replace(/[A-Z]/g, (char) => char.charCodeAt(0) - 55);

  const checksum = numericIban.match(/\d{1,7}/g).reduce((total, num) => parseInt(total + num, 10) % 97, "");

  return checksum === 1 || "Bitte eine gültige IBAN eingeben (z.B. DE12 3456 7890 1234 5678 90).";
};

export const timeRule = () => (v) => {
  if (!v) return true;
  const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
  return regex.test(v) || "Bitte eine gültige Uhrzeit im Format HH:MM eingeben (00:00 - 23:59).";
};
